<template lang="pug">
v-form
  .title N° Nota de Crédito
  v-layout(wrap)
    v-flex.xs10
      IntegerInput( 
        v-model="documentId"
        placeholder="Ingrese el n° de folio de la nota de crédito"
        @keydown.enter="fetchCreditNote"
        :rules="[v => !!v || 'Campo Obligatorio']"
        :disabled="loading"
        :loading="loading"
        :error-messages="errors"
        :max-length="30"
        )
    v-flex.xs2
      v-btn(
        color="primary"
        large
        @click="fetchCreditNote"
        :disabled="loading"
        )
        v-icon receipt
    v-flex.xs12(v-if="creditNote")
      .title Valor
      IntegerInput( 
        :value="parseInt(creditNote.total)"
        prefix="$"
        readonly
        box
        )
</template>

<script>
import IntegerInput from '@/components/reusable_components/Input/IntegerInput'
import SlSaleCreditNote from '@/models/Sale/SlSaleCreditNote'
import { mapActions, mapState } from 'vuex'
function initialState() {
    return {
        documentId: '',
        creditNote: null,
        loading: false,
        errors: null,
    }
}
export default {
    name: 'credit-note-payment',
    components: {
        IntegerInput,
    },
    props: {
        isInvoice: {
            type: Boolean,
            default: false,
        },
    },
    data: () => initialState(),
    computed: {
        ...mapState('CustomerModule', ['customerData']),
        isReady() {
            return this.creditNote && !this.creditNote.used_for_payment
        },
    },
    methods: {
        ...mapActions('CashDeskModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
        }),
        fetchCreditNote() {
            this.loading = true
            new SlSaleCreditNote()
                .where('number', this.documentId)
                .include('sl_service_order')
                .get()
                .then(r => {
                    this.creditNote = r.data[0]
                    if (this.creditNote.used_for_payment) {
                        this.$emit(
                            'error',
                            `La nota de crédito N° ${this.creditNote.number} ya ha sido usada`
                        )
                        let number = this.creditNote.number
                        Object.assign(this.$data, initialState())
                        this.errors = [
                            `La nota de crédito N° ${number} ya fue usada`,
                        ]
                    }
                    if (
                        this.creditNote.sl_customer_id !==
                            this.customerData.id &&
                        this.isInvoice
                    ) {
                        this.$emit(
                            'error',
                            `La nota de crédito N° ${this.creditNote.number} no corresponde a este cliente`
                        )
                        let number = this.creditNote.number
                        Object.assign(this.$data, initialState())
                        this.errors = [
                            `La nota de crédito N° ${number} no corresponde a este cliente`,
                        ]
                    }
                    if (
                        this.creditNote.sl_service_order &&
                        this.creditNote.sl_service_order.sl_sale_invoice_id &&
                        !this.isInvoice
                    ) {
                        this.$emit(
                            'error',
                            `La nota de crédito N° ${this.creditNote.number} correspode a una factura.`
                        )
                        let number = this.creditNote.number
                        Object.assign(this.$data, initialState())
                        this.errors = [
                            `La nota de crédito N° ${number} corresponde a una factura`,
                        ]
                    }
                })
                .catch(console.log)
                .finally(() => (this.loading = false))
        },
    },
    watch: {
        isReady: {
            immediate: true,
            handler: function(newVal) {
                if (newVal) {
                    this.setPayment(parseInt(this.creditNote.total))
                    let payload = {
                        sl_sale_credit_note_id: this.creditNote.id,
                    }
                    this.setPaymentDetail(payload)
                } else {
                    this.setPayment('')
                    this.setPaymentDetail(null)
                }
            },
        },
    },
}
</script>

<style lang="scss"></style>
